/**
 * Inc5 · Informe MAAM de resultados de una ejecución.
 *
 * Store Pinia: estado compartido del módulo y orquestación de sus servicios.
 * Las vistas no llaman a `http` ni a los servicios directamente; pasan por aquí.
 * Los servicios no lanzan, así que las acciones interpretan valores neutros
 * (`[]`, `null`, `false`) como fallo.
 */

import { defineStore } from 'pinia'
import type { ResultadosAutoevaluacion } from '@/interfaces/ResultadosAutoevaluacion'
import { getResultadosAutoevaluacionService } from '@/services/ResultadosAutoevaluacionService'

/** Store `resultadosAutoevaluacion`. Ver la cabecera del archivo para el contrato del módulo. */
export const useGestionResultadosAutoevaluacion = defineStore('resultadosAutoevaluacion', {
  state: () => ({
    resultados: null as ResultadosAutoevaluacion | null,
    cargando: false,
    error: '' as string
  }),

  actions: {
    async cargar(idEjecucion: number): Promise<void> {
      this.cargando = true
      this.error = ''
      try {
        const res = await getResultadosAutoevaluacionService(idEjecucion)
        if (res.ok) {
          this.resultados = res.data ?? null
        } else {
          this.resultados = null
          this.error = res.error ?? 'Error al cargar los resultados'
        }
      } catch {
        this.resultados = null
        this.error = 'Error de conexión al cargar los resultados'
      } finally {
        this.cargando = false
      }
    }
  }
})
